module.exports = __webpack_public_path__ + "img/TechCavAttack3_ua.8e8f49f6.webp";